<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="observationsVisible = !observationsVisible">
                  {{ $t('observations.observations') }} ({{ observations.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="observationsVisible = !observationsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:observationsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: observationsVisible }">
          <contract-observations-list
            :observations="observations"
            :observation-types="observationTypes"
            :params="searchParams"
            class="my-2"
            @observation-selected="editObservation"
          />
    </div>
    <hr class="report-divider nopads">
    <Transition name="fade">
      <observation-editor
        v-if="observation != null"
        id="editor"
        :observation="observation"
        :observations="[observation]"
        :is-observer="isObserver"
        @close="observation = null"
        @close-and-update="closeAndUpdate"
      />
    </Transition>
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import ContractObservationsList from "@/components/observation/ContractObservationsList";
import ObservationEditor from "@/components/observation/ObservationEditor";

export default {
    name: "ContractReportObservations",
    components: {ObservationEditor, ContractObservationsList},
    mixins: [restApi],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            loading: false,
            observations: [],
            observationTypes: [],
            observation: null,
            observationsVisible: false
        }
    },
    watch: {
        searchParams: function () {
            this.fetchObservations()
        }
    },
    mounted() {
        this.fetchObservations()
    },
    methods: {
        fetchObservations: function () {
            if (this.searchParams && this.searchParams.dateTo && this.searchParams.dateFrom && this.searchParams.contract) {
                this.observations = []
                this.$emit('loading', true)
                this.loading = true
                let params = {
                    from: new Date(this.searchParams.dateFrom).toISOString(),
                    to: new Date(this.searchParams.dateTo).toISOString(),
                    contract: this.searchParams.contract
                }
                this.restFetchParams(this.observationUrl, params, this.handleResponse, this.handleFail)
            }
        },
        handleResponse: function (response) {
            this.$emit('loading', false);
            this.loading = false
            this.observations = response.data;
            if (this.observations && this.observations.length > 0) {
                this.observations.forEach((observation) => {
                    // Check if the type already exists in the observationTypes array
                    const existingType = this.observationTypes.find(type => type.id === observation.type.id);

                    if (existingType) {
                        // If the type exists, increment the count
                        existingType.count = (existingType.count || 0) + 1;
                    } else {
                        // If the type doesn't exist, add it with a count of 1
                        this.observationTypes.push({
                            ...observation.type,  // Spread the existing properties of the type
                            count: 1              // Initialize the count to 1
                        });
                    }
                });
            }
        },
        handleFail: function () {
            this.$emit('loading', false)
            this.loading = false
        },
        closeAndUpdate() {
            this.observation = null
            this.fetchObservations()
        },
        editObservation(observation) {
            this.observation = this.observations.find(item => item.id === observation.id)
        }
    }
}
</script>
